// External
import React, { Component } from 'react';

// Internal
import logo from '../../assets/images/logo.png';
import * as Api from '../../utils/api';
import * as Auth from '../../utils/auth';
import './styles.css';

class LoginPage extends Component {
  state = {
    username: '',
    password: '',
    displayPassword: false
  };

  handleInputChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleLogin = () => {
    const { username, password } = this.state;

    this.props.toggleLoading(true);

    Api.login(username, password)
      .then((res) => {
        if (res.status === 200) {
          const { token, user } = res.data;

          Auth.authenticate(token, user);
          this.props.history.push('/vehicles');
        } else {
          console.log('Error login', res);
        }
      })
      .catch(console.log)
      .finally(() => this.props.toggleLoading(false));
  };

  togglePassword = () => {
    this.setState((oldState) => ({ displayPassword: !oldState.displayPassword }));
  };

  render() {
    const { username, password } = this.state;
    const isButtonEnabled = !!username && !!password;

    return (
      <div className="container">
        <div className="container-wrapper">
          <div className="image-container">
            <img className="logo-image" src={ logo }/>
          </div>
          <div className="card-panel login-form">
            <div className="input-field">
              <input id="username" type="text" value={ this.state.value }
                     onChange={ this.handleInputChange }/>
              <label htmlFor="username">Username</label>
            </div>
            <div className="input-field">
              <input id="password" type={ `${this.state.displayPassword ? 'text' : 'password'}` }
                     value={ this.state.value } onChange={ this.handleInputChange }/>
              <label htmlFor="password">Password</label>
              <i className="material-icons prefix postfix"
                 onClick={ this.togglePassword }>{ this.state.displayPassword ? 'visibility_off' : 'visibility' }</i>
            </div>
            <a className={ `waves-effect waves-light btn login-button ${isButtonEnabled ? '' : 'disabled' }` }
               onClick={ this.handleLogin }>Login</a>
          </div>
        </div>
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/pages/login/index.js